import { render, staticRenderFns } from "./AnswerPreview.vue?vue&type=template&id=18be9db3&"
import script from "./AnswerPreview.vue?vue&type=script&lang=js&"
export * from "./AnswerPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports